import React, { useEffect, useState } from "react";
import { View, TouchableOpacity } from "react-native";

import Text from "components/Text";
import Icon from "components/Icon";
import Input from "components/Input";
import Empty from "components/Empty";
import Error from "components/Error";
import Loading from "components/Loading";
import ModalInfinityList from "components/ModalInfinityList";
import AnimatedInfinityList from "components/AnimatedInfinityList";

import { styles } from "./styles";
import { sizes, colors, strings } from "assets/constants";

import { useFlag } from "hooks";
import { liveSearchInput, mq } from "utils";

import { useCoWorkers } from "clients/apis";

let timer: ReturnType<typeof setTimeout>;

export default function CoWorkerPicker(props: PickerT) {
  const { value, onSelect, disabled } = props;
  const val = value as CoWorkerPickerItemT;

  const [name, setName] = useState("");
  const {
    refetch,
    isError,
    error: customerError,
    isRefetching,
    isLoading: customersLoading,
    data: customers,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useCoWorkers({ name });

  const { flg: modal, on: show, off: hide } = useFlag();
  const { flg: typing, on: startTyping, off: stopTyping } = useFlag();

  const _onClosePicker = () => {
    setName("");
    hide();
  };

  const [valueState, setValueState] = useState<
    CustomerPickerItemT | undefined
  >();

  useEffect(() => {
    setValueState(val);
  }, [val]);

  const _renderItem = (items: []) => {
    return items.map((customer: CustomerPickerItemT, key: number) => (
      <TouchableOpacity
        key={String(key)}
        style={styles.item}
        onPress={() => {
          onSelect && onSelect(customer);
          setValueState(customer);
          _onClosePicker();
        }}
      >
        <Text>{customer.name}</Text>
      </TouchableOpacity>
    ));
  };

  const _renderList = () => {
    if (customersLoading || typing) {
      return <Loading style={{ marginTop: mq(20) }} />;
    }

    if (isError) {
      return (
        <Error error={customerError} reset={refetch} loading={isRefetching} />
      );
    }

    if (customers?.pages?.[0]?.data?.data?.length === 0) {
      return <Empty message={strings.no_item_found} />;
    }

    return (
      <AnimatedInfinityList
        onRefresh={refetch}
        responseData={customers}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        renderItemList={_renderItem}
      />
    );
  };

  return (
    <>
      <TouchableOpacity
        disabled={disabled}
        onPress={show}
        activeOpacity={sizes.tapOpacity}
        style={{ ...styles.inputContainer }}
      >
        <View style={styles.iconContainer}>
          <Icon name="chevron-down" />
        </View>
        <View style={styles.textContainer}>
          <Text
            color={valueState ? colors.textColorDefault : colors.placeholder}
          >
            {valueState?.name || strings.pick_co_worker}
          </Text>
        </View>

        <View style={styles.iconContainer}>
          <Icon name="users" />
        </View>
      </TouchableOpacity>

      <ModalInfinityList close={_onClosePicker} visible={modal}>
        <View style={styles.listSearchContainer}>
          <Input
            hideError
            icon={{ name: "search" }}
            placeholder={strings.search}
            onChangeText={(inputName) =>
              liveSearchInput(
                inputName,
                name,
                setName,
                timer,
                startTyping,
                stopTyping
              )
            }
          />
        </View>
        {_renderList()}
      </ModalInfinityList>
    </>
  );
}
